<template>
  <div class="zoom-container" ref="zoomContainer">

    <img class="map" :class="{ 'map-dimmed' : dimMap }" src="@/assets/map.svg" />

    <div class="line">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1921.5 1079.42">
        <g id="Layer_2" data-name="Layer 2">
          <g id="everything">
            <path fill="url(#radial-gradient)" class="cls-2" :class="{ 'highlighted' : highlightLine }" d="M517.54,190.93C537.77,143.2,530.42,84.7,489.65,49.82c-33.89-29-86.76-37.86-127.48-18.41C343.49,40.33,331,56.06,318.23,71.7,304.12,89,288.1,102.5,265.66,107.1c-42.5,8.71-77-18.74-113.76-34.37-10.46-4.45-23.8-8.24-33.09.71-6.38,6.16-8.43,15.49-9.31,24-3,29.28,6.66,60.55,16.55,87.67C159.58,277,222.78,361.12,302.37,418c39.47,28.2,83.27,46.13,130.16,57.68,37.6,9.25,75.72,16.74,108.64,38.31,36.32,23.8,65.13,60.5,83.6,99.54,16.62,35.15,24.48,73.64,32.12,111.52,10,49.73,20.53,99.22,35.83,147.65,4.4,13.92,9.41,27.61,14.06,41.45,2.2,6.55,7.93,21.33-.21,25.7-9.65,5.18-27.3-2.94-36.16-6.49a261.82,261.82,0,0,1-45.82-24.41,170.21,170.21,0,0,1-17.16-12.55,63.86,63.86,0,0,1-5.75-5.4c-1.07-1.2-2.28-2.66-2.22-2.66.38-.05-2.15,4.7-2.39,3.87.08.26-1-.35.42.09,1.26.38.93.06,1.69.17,4.8.7,9.56,2.42,14.15,3.93,14.49,4.78,28.73,10.31,43.16,15.3,30.88,10.68,66.39,23.21,99.54,18,27.24-4.3,39.52-25.75,41-51.6,1.93-34.94-10-70.9-22.75-102.9-18.07-45.4-42.08-88.43-69.56-128.78C673.19,600.13,636.85,557,595.6,519.2c-38.77-35.55-82.39-64.72-122.7-98.33-35.06-29.22-63-63.53-75.92-108-9.14-31.52-14.45-66.46-7.7-98.92,4.69-22.51,16.11-42.28,36.09-54.43C448.73,145.32,477.54,140,504,134.6c45.75-9.38,93.26-4,138.21-17.54,40.65-12.23,76.84-35.66,117-49.23,55.31-18.66,114.38-24.66,172.5-21.14,41.22,2.49,82.76,8,122.08,21,16.89,5.59,33.56,11.78,50.72,16.58,26.85,7.5,54.4,12.44,82,16.22,23.32,3.2,46.72,5.12,70.16,7.1,14.13,1.19,29.32,2,42.53,7.66,43.86,18.77,38.25,79.32,33,117.51-3.87,28-8.63,55.89-17.49,82.79-6.34,19.24-14.86,37.47-24.1,55.45-8.28,16.15-16.61,32.27-22.93,49.31-8.46,22.78-13.23,46.83-15.24,71-4.42,53.28,5,108.17,25.24,157.58,7.82,19.14,17.11,37.88,29.17,54.74,7.84,11,17.24,22.93,29.54,29.16,12.53,6.34,22.95,1.84,30.67-9.32,5.17-7.47,9.26-15.85,16.71-21.44,10.23-7.67,23.19-7.54,34.75-3.25,26.16,9.68,46.15,32,70.65,45,23.67,12.54,49.6,19.53,76.17,22.3,24.17,2.51,48.48,1.41,72.66-.35,19-1.38,38.62-4,57.59-1.67,13.51,1.69,26.31,7.78,29,22.39,2.94,16-6.11,33.48-11.27,48.12-6.94,19.7-12.12,40.19-10.75,61.26,1.56,24.09,10.81,47.12,25,66.54l3.58-8.81c-19.71,5.28-40.52,7-60.71,3.48-15.76-2.74-31.24-8.52-47.47-7.19-15.17,1.24-26.88,8.9-38.81,17.63-3.71,2.71-8.68,7.2-13.59,7-7.9-.3-11.72-10.49-13.64-16.73-2.27-7.36-13.86-4.22-11.57,3.19,4.24,13.76,14.92,29.53,31.45,24.56,14-4.19,23.33-17.43,37.46-21.87,18.39-5.77,37.14,2.5,55.26,5.36a156,156,0,0,0,64.81-3.86c3.45-.92,5.9-5.64,3.59-8.81-15.39-21.14-24.63-46.3-23.44-72.65,1-21,8.65-40.53,15.54-60.14,5.19-14.77,10.36-31.42,4.2-46.71-5.4-13.42-17.51-21-31.34-23.7-17.89-3.44-36.59-1.5-54.6-.16-23.61,1.76-47.27,3.49-71,2.09-28-1.66-55.85-8-80.85-21s-45-34.44-71.12-45.36c-20.74-8.69-43.36-5.25-57.77,12.77-6.55,8.18-12.41,27-25.1,21-12.4-5.83-21.78-19.42-29.08-30.44-12.32-18.61-21.86-39.06-29.38-60-19-52.77-26.21-111-16.16-166.39a248.87,248.87,0,0,1,18.92-60c7.61-16.48,16.55-32.3,24.26-48.73,22.06-47,32.37-99.17,36.11-150.77,2.77-38.32-4.43-86.16-44.69-102.37-13.34-5.37-28.14-6.55-42.34-7.8-23.95-2.11-47.91-3.86-71.75-7.15-27.45-3.79-54.85-8.78-81.55-16.3-17.33-4.89-34.16-11.2-51.26-16.8C1016.4,42.78,974.92,37.45,934,34.83c-57.79-3.71-116.78,1.84-172.07,19.52-41.24,13.19-78,36.84-119.17,50-44.56,14.24-91.87,9-137.48,17.81-26.55,5.12-54.61,10.76-78.89,23.11a89.33,89.33,0,0,0-43.67,48.41c-13.21,34.41-9.08,74.57-.63,109.65,9.51,39.52,28.64,74.35,57.27,103.24,34.42,34.72,76.4,61.26,114.15,92.07,84.75,69.17,154.65,158.18,199.92,258,15.48,34.13,30,71.89,31.63,109.76.51,11.59,0,24.35-5.52,34.85C773.8,912.07,763,917,751.15,918.29,717.49,922.1,681.64,908,650.52,896.9c-13.3-4.73-26.49-10-40-14-6.23-1.83-17.65-5.76-22,1.54-5,8.44,7.23,17.83,12.7,22.27a251.71,251.71,0,0,0,40.25,26.13c14.51,7.75,30.1,15.19,46.31,18.55,11.11,2.3,25.94,3.15,32.25-8.48,4.92-9.06,1.9-21-1-30.17-4.34-13.58-9.45-26.92-13.78-40.51-8.57-26.88-15.92-54.13-22.26-81.61-9.76-42.3-16.31-85.41-27.65-127.34C634,584.54,583.11,510.88,503.91,482.38c-37.67-13.55-77.78-18.58-115.48-32.21-52.68-19.05-98.63-52.62-137.77-92.26a512.93,512.93,0,0,1-88.82-121.77c-17.52-33.37-32.34-69.38-38.65-106.72C121.25,118,119.85,105.6,122,94.1c1.31-7,3.55-14.3,11.72-14.2,6.18.08,12.53,3.23,18,5.83,8.32,4,16.37,8.49,24.55,12.72,18.37,9.52,37.59,18.16,58.24,21.1,22,3.13,45-.73,64-12.74,17-10.78,28-27.22,41-42.1,15.13-17.32,34-28,57-30.69C420,31.28,444.6,35.7,465.3,47.33c48.41,27.19,62.83,88.1,41.88,137.54-3,7,7.35,13.16,10.36,6.06Z"/>
          </g>
        </g>
        <defs>
          <radialGradient id="radial-gradient" cx="923.86" cy="503.7" r="664.56" gradientUnits="userSpaceOnUse">
            <stop offset="0" stop-color="#ce7d91"/>
            <stop offset="0.33" stop-color="#efffad"/>
            <stop offset="0.38" stop-color="#e8fcaf"/>
            <stop offset="0.46" stop-color="#d5f2b3"/>
            <stop offset="0.55" stop-color="#b5e3ba"/>
            <stop offset="0.65" stop-color="#89cec4"/>
            <stop offset="0.68" stop-color="#7ac7c7"/>
            <stop offset="1" stop-color="#daabff"/>
          </radialGradient>
        </defs>
      </svg>
    </div>

    <div class="overlay">
      <div
        v-for="(post, index) in posts"
        :key="post.data.key"
        :style="{
          left: `${post.data.x}`,
          top: `${post.data.y}`,
          zIndex: post.data.zIndex ? post.data.zIndex : 100
        }"
        :class="['circle-container', { 'selected': selectedPostIndex === post.data.key, ...colorClass }]"
        @click="goToPost(index)"
        @mouseenter="onCircleHover(true, $event, post.data.location, post.data.title)"
        @mouseleave="onCircleHover(false)"
        @mousemove="updateTooltipPosition($event)"
      >
        <div class="circle invisible">
          <div class="circle filled">
            <div class="circle-number">{{ index + 1 }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="tooltip" :class="{ 'tooltip-visible' : showTooltip }" ref="tooltip">
      <div class="tooltip-location">{{ tooltipLocation }}: {{ tooltipTitle }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Map',
  data () {
    return {
      highlightLine: false,
      dimMap: false,
      showTooltip: false,
      tooltipLocation: '',
      tooltipTitle: '',
    }
  },
  computed: {
    posts () {
      return this.$store.state.posts
    },
    selectedPostIndex () {
      return this.$store.state.selectedPostIndex
    },
    colorClass () {
      return this.$store.getters.colorClass
    }
  },
  methods: {
    onCircleHover (isHovered, event, location, title) {
      this.highlightLine = isHovered
      this.dimMap = isHovered
      if (isHovered) {
        this.tooltipLocation = location
        this.tooltipTitle = title
        this.updateTooltipPosition(event)
      }
      this.showTooltip = isHovered
    },
    goToPost (index) {
      this.$emit('go-to-post', index)
    },
    updateTooltipPosition (event) {
      const tooltip = this.$refs.tooltip
      const zoomContainer = this.$refs.zoomContainer
      if (tooltip && zoomContainer) {
        const rect = zoomContainer.getBoundingClientRect()
        const offsetX = 30
        const offsetY = -20

        const x = event.clientX - rect.left + offsetX
        const y = event.clientY - rect.top + offsetY

        tooltip.style.left = `${x}px`
        tooltip.style.top = `${y}px`
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import '../main.scss';

$sircle-size-map: 35px;
$circle-font-size: 16px;

$circle-size-md: 20px;
$circle-font-size-md: 10px;

.tooltip {
  top: 0;
  left: 0;
  min-width: 200px;
  max-width: 300px;
  overflow: visible;
  position: absolute;
  display: block;
  background-color: $black;
  font-family: 'HedvigLetters';
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  color: $cappuccino-dark;
  padding: 5px 10px;
  border-radius: 5px;
  pointer-events: none;
  z-index: 999;
  opacity: 0;
  -webkit-transition: opacity 0.4s ease, top 0.1s ease, left 0.1s ease;
  -moz-transition: opacity 0.4s ease, top 0.1s ease, left 0.1s ease;
  -o-transition: opacity 0.4s ease, top 0.1s ease, left 0.1s ease;
  transition: opacity 0.4s ease, top 0.1s ease, left 0.1s ease;
}

.tooltip-visible {
  opacity: 1;
}

.zoom-container {
  position: relative;
  width: 100%;
  aspect-ratio: 10 / 5.7;
  border-radius: 4px;
  overflow: visible;
}

.map, .line {
  border-radius: 4px;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 1;
  transition: opacity 0.8s ease;
}

.map-dimmed {
  opacity: 0.8;
}

.cls-2 {
  opacity: 0.8;
  transition: opacity 0.8s ease;
}

.highlighted {
  opacity: 1;
}

.cls-2:hover {
  opacity: 1;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  transform-origin: top left;
  transition: transform 0.3s ease;
}

.circle-container {
  position: absolute;
  width: $sircle-size-map;
  height: $circle-size-map;
  pointer-events: auto;
  transform: translate(-50%, -50%);

  @media only screen and (max-width: 1000px) {
    width: $circle-size-md;
    height: $circle-size-md;
  }
}

.circle {
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  transition: box-shadow 0.6s ease, background-color 0.6s ease;
}

.invisible {
  box-shadow: 0px 0px 4px $cappuccino;
  background-color: transparent;
  transition: box-shadow 0.6s ease;
}

.filled {
  background-color: $cappuccino;
}

.circle-number {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: $black;
  font-family: 'HedvigLetters';
  font-size: $circle-font-size;
  font-weight: bold;
  transition: color 0.6s ease;

  @media only screen and (max-width: 1000px) {
    font-size: $circle-font-size-md;
  }
}

// hovered
.circle-container:hover {
  z-index: 500 !important;
}

.circle-container:hover .invisible {
  box-shadow: 0 0 18px $green-light;
  transition: box-shadow 0.6s ease;
}
.circle-container.blue:hover .invisible {
  box-shadow: 0 0 18px $blue-light;
}

.circle-container:hover .circle-number {
  color: $green-light;
  transition: color 0.6s ease;
}
.circle-container.blue:hover .circle-number {
  color: $blue-light;
}

.circle-container:hover .circle {
  background-color: $cappuccino-dark;
  transition: background-color 0.6s ease;
}

// selected
.selected {
  z-index: 400 !important;
}

.selected .invisible {
  box-shadow: 0 0 18px $green-light;
}
.selected.blue .invisible {
  box-shadow: 0 0 18px $blue-light;
}

.selected .circle-number {
  color: $green-light;
}
.selected.blue .circle-number {
  color: $blue-light;
}

.selected .circle {
  background-color: $cappuccino-dark;
}

</style>